import type { ColumnDef, SankeyMapping } from '@deckspace/types';
import { rowsToColumnar, getColumn } from '../shared/pivot.js';

export interface SankeyResult {
  sankeyNodes: { name: string }[];
  sankeyLinks: { source: number; target: number; value: number }[];
}

export function prepSankeySeries(
  rows: Record<string, unknown>[],
  _columnDefs: ColumnDef[],
  mapping: SankeyMapping
): SankeyResult {
  const tableData = rowsToColumnar(rows);
  const sources = getColumn<string>(tableData, mapping.source).map(String);
  const targets = getColumn<string>(tableData, mapping.target).map(String);
  const values = getColumn<number>(tableData, mapping.value).map((v) => Number(v) || 0);

  const nodeSet = new Set<string>();
  for (const s of sources) nodeSet.add(s);
  for (const t of targets) nodeSet.add(t);

  const sankeyNodes = [...nodeSet].map((name) => ({ name }));
  const nodeIndex = new Map(sankeyNodes.map((n, i) => [n.name, i]));

  const sankeyLinks = sources.map((src, i) => ({
    source: nodeIndex.get(src) ?? 0,
    target: nodeIndex.get(targets[i] ?? '') ?? 0,
    value: values[i] ?? 0,
  }));

  return { sankeyNodes, sankeyLinks };
}
